import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Typography } from "@mui/material";
import { supplierPendingInventoryActivityReportEndpoints } from "../../../../requests/api-endpoints";
import request from '../../../../util/SuperagentUtils';
import { getErrorMessageForNonStandardAndStandardResponse } from "../../../../util/NetworkErrorUtil";
import { ReportDialogProps } from "../../../../interfaces";
import { PendingInventoryActivityVO } from "../../../../types/model/valueObject/pendinginventoryactivity/PendingInventoryActivityVO";
import { useSnackbar } from '../../../../context/snackbar-context';
import {
  DialogComparisonContainer,
  DialogComparisonRow
} from '../../../cardComponents';

const DismissSupplierPendingInventoryActivityDialog = ({
    open,
    item,
    onClose,
}: ReportDialogProps<PendingInventoryActivityVO>) => {
  const { snackbarShowMessage } = useSnackbar();

  const handleCancelDialog = () => {
    onClose({item});
  };

  const handleSubmit = () => {
    if (!item) {
      snackbarShowMessage('Unable to dismiss inventory activity. Please contact support.', 'error');
      onClose({item, action: 'ERROR'});
      return;
    }
    request.post(supplierPendingInventoryActivityReportEndpoints.actions.dismiss(item.id)).send()
      .then(() => {
          snackbarShowMessage(`Successfully dismissed inventory activity`, 'success');
          onClose({item, action: 'SUCCESS'});
      }).catch((err: any) => snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(err), 'error'));
  };

  return <Dialog open={open}>
    <DialogTitle>Dismiss Activity</DialogTitle>
    <DialogContent>
      <Typography>Are you sure you want to dismiss this inventory activity?</Typography>
      <DialogComparisonContainer>
        <DialogComparisonRow label="Event Type:" value={item?.eventTypeLabel} />
        <DialogComparisonRow label="Date/Time:" value={item?.eventDatetime} />
        <DialogComparisonRow label="Booking Number:" value={item?.bookingNumber} />
      </DialogComparisonContainer>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCancelDialog}>Cancel</Button>
      <Button onClick={handleSubmit}>Dismiss</Button>
    </DialogActions>
  </Dialog>
};

export { DismissSupplierPendingInventoryActivityDialog };
